let mainList = [];

const CustomMultiselectListManage = (type, element, selectedValue, input) => {
  switch (type) {
    case "initial":
      return initial(element, selectedValue);

    case "add":
      return add(element, selectedValue);

    case "remove":
      return remove(element, selectedValue);

    case "toggleItem":
      return toggleItem(input);

    default:
      return mainList;
  }
};

function remove(element, selectedValue) {
  selectedValue = String(selectedValue.id).split(",");
  for (let index = 0; index < mainList.length; index++) {
    let existsValue = mainList[index];
    if (element.dataset.id === existsValue["id"]) {
      let existsValues = String(existsValue["value"]).split(",");
      let isExists = selectedValue.some((el) => existsValues.includes(el));
      if (isExists) mainList.splice(index, 1);
    }
  }
}

function initial(element, selectedValue) {
  for (let index = 0; index < selectedValue.length; index++) {
    const selected = selectedValue[index];
    let obj = {};
    obj["id"] = element.dataset.id;
    obj["value"] = selected.value;
    obj["text"] = selected.text;
    mainList.push(obj);
  }
}

function add(element, selectedValue) {
  let obj = {};
  let item = selectedValue.item;
  obj["id"] = element.dataset.id;
  obj["value"] = item.value;
  obj["text"] = item.text;
  mainList.push(obj);
}

function toggleItem(input) {
  for (let index = 0; index < mainList.length; index++) {
    const existsItem = mainList[index];
    // we need to find parent ITEM to get ID
    let pn = input.parentNode;
    for (let i = 0; i < 5; i++) {
      pn = pn.parentNode;
    }
    const multiselectID = pn.dataset.id;
    if (existsItem["id"] == multiselectID) {
      let inputValue = input.dataset.value;
      // converting String > Array to check easy using some and includes
      inputValue = String(inputValue).split(",");
      let existsValue = String(existsItem["value"]).split(",");

      // there is an already item,we will not add
      // and start a error occured dispatch
      if (existsValue.some((el) => inputValue.includes(el))) {
        return false;
      }
    }
  }
  return true;
}

export default CustomMultiselectListManage;
